import { forwardRef, FC } from 'react'

import { clsx } from 'clsx'

import { ExclamationCircleIcon } from '../icons/index.js'
import { useInputColors } from '../utils/styles/index.js'

export type TextareaProps = React.ComponentProps<'textarea'> & {
  invalid?: boolean
}
/**
 * The Textarea component allows you to easily create multi-line text inputs.
 */
export const Textarea: FC<TextareaProps> = forwardRef<
  HTMLTextAreaElement,
  TextareaProps
>(({ invalid = false, hidden, className, disabled, ...rest }, ref) => {
  const { inputClsx } = useInputColors({
    invalid,
    disabled,
  })

  return (
    <div
      className={clsx('flex relative rounded-md shadow-sm', hidden && 'hidden')}
    >
      <textarea
        ref={ref}
        className={clsx(
          ' block w-full rounded-md',
          inputClsx,
          invalid && 'pe-10',
          className,
        )}
        rows={4}
        disabled={disabled}
        hidden={hidden}
        {...rest}
      />

      {invalid && (
        <div className="absolute top-0 end-0 pe-3 pt-3 flex items-center pointer-events-none">
          <ExclamationCircleIcon
            className="h-5 w-5 text-action-destructive"
            aria-hidden="true"
          />
        </div>
      )}
    </div>
  )
})
